import React, { useState } from "react";
import { Sliders, Layers, Palette, Package } from "lucide-react";
import SiteSettingsPanel from "./SiteSettingsPanel";
import ProductsManager from "./ProductsManager";
import ColourwaysManager from "./ColourwaysManager";
import BundlesManager from "./BundlesManager";

const SECTIONS = [
  { key: "settings", label: "Site Settings", Icon: Sliders },
  { key: "products", label: "Products", Icon: Layers },
  { key: "colourways", label: "Colourways · Stock", Icon: Palette },
  { key: "bundles", label: "Bundles", Icon: Package },
];

/**
 * SiteControlTab — top-level admin CMS hub. Lets a non-engineer manage the
 * full catalog (products / colourways / bundles), set per-colourway stock for
 * scarcity badges, and edit site-wide settings (shipping, hero copy, season).
 */
const SiteControlTab = ({ authClient }) => {
  const [section, setSection] = useState("settings");
  const [products, setProducts] = useState([]);

  return (
    <div data-testid="site-control-tab">
      <div className="flex flex-wrap gap-1 border-b border-line mb-6">
        {SECTIONS.map(({ key, label, Icon }) => (
          <button
            key={key}
            type="button"
            onClick={() => setSection(key)}
            className={`px-4 py-2.5 text-[11px] tracking-[0.18em] uppercase font-bold border-b-2 -mb-px inline-flex items-center gap-2 ${
              section === key
                ? "border-ink text-ink"
                : "border-transparent text-mute hover:text-ink"
            }`}
            data-testid={`site-control-section-${key}`}
          >
            <Icon size={13} />
            {label}
          </button>
        ))}
      </div>

      {section === "settings" && <SiteSettingsPanel authClient={authClient} />}
      {section === "products" && (
        <ProductsManager authClient={authClient} onProductsChange={setProducts} />
      )}
      {section === "colourways" && (
        <ColourwaysManager authClient={authClient} products={products} />
      )}
      {section === "bundles" && <BundlesManager authClient={authClient} />}
    </div>
  );
};

export default SiteControlTab;
